<script>
import { required, integer, minValue, maxValue } from "vuelidate/lib/validators";

export default {
  name: "pkf-form",
  props: {
    value: { type: Object, default: () => {} },
  },

  data: (vm) => ({
    form: {
      specs: {
        hip_width: 0,
        distance_hip_shoe: 0,
        distance_knee_shoe: 0,
        shoe_length: 150,
        hip_block_width: 20,
        plank_size: null,
      },
      ...vm.value,
    },
  }),
  validations: {
    form: {
      specs: {
        hip_width: {
          required,
          integer,
          minValue: minValue(100),
          maxValue: maxValue(800),
        },
        distance_hip_shoe: {
          required,
          integer,
          minValue: minValue(100),
          maxValue: maxValue(1000),
        },
        distance_knee_shoe: {
          required,
          integer,
          minValue: minValue(100),
          maxValue: maxValue(1000),
        },
        shoe_length: {
          required,
          integer,
          minValue: minValue(150),
          maxValue: maxValue(270),
        },
        hip_block_width: {
          required,
        },
        plank_size: {
          required,
        },
      },
    },
  },
  methods: {
    validate() {
      if (!this.$v && !this.$v.form) return true;
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.$emit("validated", { ...this.form });
        this.$emit("input", { ...this.form });
      }

      return !this.$v.form.$invalid;
    },
  },
};
</script>
<template>
  <b-row>
    <b-col cols="12" sm="12" md="6" lg="5"
      ><img
        src="@/assets/images/forms/pkf.png"
        alt
        style="height: auto; max-width: 100%"
        class="dimg-fluid p-3"
    /></b-col>
    <b-col cols="12" xs="12" sm="12" md="6" lg="7">
      <g-form-error-wrapper :validations="$v.form.specs.hip_width">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            v-model.number="form.specs.hip_width"
            :label="$t('Hip Width')"
            prepend="A"
            append="mm"
            maxWidth="100px"
            text-align="center"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.hip_width.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-text-input>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.distance_hip_shoe">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            v-model.number="form.specs.distance_hip_shoe"
            :label="$t('Distance Hip vs Shoe')"
            prepend="B"
            append="mm"
            maxWidth="100px"
            text-align="center"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.distance_hip_shoe.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-text-input>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.distance_knee_shoe">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            v-model.number="form.specs.distance_knee_shoe"
            :label="$t('Distance Knee vs Shoe')"
            prepend="C"
            append="mm"
            maxWidth="100px"
            text-align="center"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.distance_knee_shoe.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-text-input>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.shoe_length">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.shoe_length"
            :label="$t('Footplate Length')"
            prepend="D"
            append="mm"
            maxWidth="100px"
            :options="[
              { value: 150, text: '150' },
              { value: 170, text: '170' },
              { value: 200, text: '200' },
              { value: 230, text: '230' },
              { value: 250, text: '250' },
              { value: 270, text: '270' },
            ]"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.shoe_length.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.hip_block_width">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.hip_block_width"
            :label="$t('Hip Block Width')"
            prepend="E"
            append="mm"
            maxWidth="100px"
            :options="[
              { value: 10, text: '10' },
              { value: 20, text: '20' },
              { value: 30, text: '30' },
              { value: 40, text: '40' },
            ]"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.hip_block_width.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.plank_size">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.plank_size"
            :label="$t('Plank')"
            width="100%"
            :options="[
              { value: null, text: '- Select a Plank Size -' },
              { value: 'no_plank', text: $t('No Plank') },
              { value: 'large', text: $t('Large') },
              { value: 'small', text: $t('Small') },
            ]"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.plank_size.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>
    </b-col>

    <b-col cols="12"
      ><label for="comments">{{ $t("comments") }}</label>
      <b-form-textarea
        id="comments"
        :placeholder="$t('extra comments or requirements')"
        v-model="form.comments"
        rows="4"
        max-rows="4"
    /></b-col>
  </b-row>
</template>
